<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.tppr_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.tppr_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVProduto()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 1rem">
					<InputText
						v-model="model.tppr_ds_descricao"
						:label="$t('description') + '*'"
					/>
					<InputText
						v-model="model.tppr_md_diametro_min"
						:label="`${$t('minDiameter')} (cm)` + '*'"
					/>
					<InputText
						v-model="model.tppr_md_diametro_max"
						:label="`${$t('maxDiameter')} (cm)` + '*'"
						:help="helpDiamtreoMaximo"
					/>
					<InputText
						v-model="model.tppr_md_comprimento_tora"
						:label="`${$t('logLength')} (m)` + '*'"
						:help="helpTora"
					/>

					<!-- <InputText
            :label="`${$t('minLength')} (cm)`"
            v-model.number="model.tppr_md_comprimento_min"
            type="number"
          /> -->
					<!-- <InputText
          :label="`${$t('maxLength')} (cm)`"
          v-model.number="model.tppr_md_comprimento_max"
          type="number"
        /> -->

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('save')"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							@click="saveClick()"
						/>
						<Button
							:label="$t('cancel')"
							color="trv-default"
							semantic-class="mini"
							outlined
							@click="changeFormAndCloseAllActions"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'
import { TheMask } from 'vue-the-mask'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createProduto,
	deleteProdutoByIdList,
	getAllProdutos,
	updateProduto,
} from '../../../../services/requests/ProdutoRequest'

import validarProduto from '../../../../validations/ProdutoValidation'
import { exportarCsv } from '../../../../utils/csvHellpers'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		KebabMenu,
		ExclusionAlert,
	},
	directives: {
		TheMask,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			headersSelecionados: [
				'tppr_cd_codigo',
				'tppr_md_comprimento_max',
				'tppr_md_comprimento_min',
				'tppr_md_diametro_max',
				'tppr_ds_descricao',
				'tppr_md_diametro_min',
				'tppr_md_comprimento_tora',
			],
			showExclusionAlert: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				tppr_ds_descricao: '',
				tppr_md_diametro_min: '',
				tppr_md_diametro_max: '',
				tppr_md_comprimento_min: '',
				tppr_md_comprimento_max: '',
				tppr_md_comprimento_tora: '0,1',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'PR',
				subtitleCardPropertie: 'tppr_ds_descricao',
				titleCardPropertie: 'tppr_cd_codigo',
			},
			tableHeaders: [
				{ key: 'tppr_cd_codigo', value: this.$t('code'), isActive: true },
				{
					key: 'tppr_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'tppr_md_diametro_min',
					value: this.$t('minDiameter'),
					isActive: true,
				},
				{
					key: 'tppr_md_diametro_max',
					value: this.$t('maxDiameter'),
					isActive: true,
				},
				{
					key: 'tppr_md_comprimento_tora',
					value: this.$t('logLength'),
					isActive: true,
				},
			],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		isMaxHigherThenMin() {
			const max = parseFloat(this.model.tppr_md_diametro_max.replace(',', '.'))
			const min = parseFloat(this.model.tppr_md_diametro_min.replace(',', '.'))
			if (isNaN(max) || isNaN(min)) {
				return false
			}
			return max > min
		},
		helpDiamtreoMaximo() {
			if (!this.model.tppr_md_diametro_max || !this.model.tppr_md_diametro_min) {
				return undefined
			}
			return !this.isMaxHigherThenMin ? { message: this.$t('maxDiameterMustBeHigher') } : undefined
		},

		isToraHigher() {
			// Verificar se this.model.tppr_md_comprimento_tora é uma string
			if (typeof this.model.tppr_md_comprimento_tora !== 'string') {
				// Se não for uma string, retorna falso ou lança um erro, dependendo do comportamento desejado
				return false // ou lança um erro: throw new Error('Valor não é uma string');
			}
			const valorComPonto = this.model.tppr_md_comprimento_tora.replace(',', '.').toString()
			// Converter a string para um número
			const valorNumerico = parseFloat(valorComPonto)
			// Verificar se o valor é maior ou igual a 0.1
			return valorNumerico >= 0.1
		},
		helpTora() {
			return !this.isToraHigher ? { message: this.$t('Loglengthmustbegreater') } : undefined
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return (
				this.model.tppr_ds_descricao &&
				this.model.tppr_md_diametro_min &&
				this.model.tppr_md_diametro_max &&
				this.isMaxHigherThenMin &&
				this.isToraHigher
			)
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['tppr_cd_codigo']
		getAllProdutos().then((response) => {
			const { result: produtos } = response.data
			produtos.forEach((produto) => {
				this.formataProdutoParaTabela(produto)
			})
			this.modelList = produtos
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createProdutoToPost() {
			return {
				id: uuidv4(),
				tppr_ds_descricao: this.model.tppr_ds_descricao.trim(),
				tppr_md_diametro_min: this.model.tppr_md_diametro_min,
				tppr_md_diametro_max: this.model.tppr_md_diametro_max,
				tppr_md_comprimento_min: this.model.tppr_md_comprimento_tora,
				tppr_md_comprimento_max: this.model.tppr_md_comprimento_tora,
				tppr_md_comprimento_tora: this.model.tppr_md_comprimento_tora,
			}
		},
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		updateProdutoToPost() {
			return {
				id: this.model.id,
				tppr_ds_descricao: this.model.tppr_ds_descricao.trim(),
				tppr_md_diametro_min: this.model.tppr_md_diametro_min.replace(',', '.'),
				tppr_md_diametro_max: this.model.tppr_md_diametro_max.replace(',', '.'),
				tppr_md_comprimento_min: this.model.tppr_md_comprimento_tora.replace(',', '.'),
				tppr_md_comprimento_max: this.model.tppr_md_comprimento_tora.replace(',', '.'),
				tppr_md_comprimento_tora: this.model.tppr_md_comprimento_tora.replace(',', '.'),
			}
		},

		downloadCSVProduto() {
			let cabecalhoDoCsvProduto = [
				'Código',
				'Descrição',
				'Diâmetro Mínimo',
				'Diâmetro Máximo',
				'Comprimento de Tora',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.tppr_cd_codigo,
				item.tppr_ds_descricao,
				item.tppr_md_diametro_min,
				item.tppr_md_diametro_max,
				item.tppr_md_comprimento_tora,
			])

			exportarCsv('export_produto', cabecalhoDoCsvProduto, linhas)
		},

		checkComma(e) {
			if (e.key === ',') {
				e.preventDefault()
				alert(this.$t('campoNaoPodeConterVirgula'))
			}
		},
		recarregaProdutos() {
			getAllProdutos().then((response) => {
				const { result: produtos } = response.data
				produtos.forEach((produto) => {
					this.formataProdutoParaTabela(produto)
				})
				this.modelList = produtos
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Cria novo produto no banco de dados
		 */
		create() {
			const produto = this.createProdutoToPost()

			if (produto.tppr_md_diametro_min.includes(',')) {
				produto.tppr_md_diametro_min = produto.tppr_md_diametro_min.replace(',', '.')
			}
			if (produto.tppr_md_diametro_max.includes(',')) {
				produto.tppr_md_diametro_max = produto.tppr_md_diametro_max.replace(',', '.')
			}
			if (produto.tppr_md_comprimento_min.includes(',')) {
				produto.tppr_md_comprimento_min = produto.tppr_md_comprimento_min.replace(',', '.')
			}

			const { isValid, message } = validarProduto(produto, this.modelList)

			if (isValid) {
				createProduto(produto)
					.then((response) => {
						const { result: produto, responseException } = response.data
						this.disableSaveButton = false

						if (!responseException) {
							this.cleanModel()
							this.formataProdutoParaTabela(produto)
							this.modelList.unshift(produto)

							this.showForm = false
							this.emptyValue = ''
							this.recarregaProdutos()
							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
						} else {
							this.mutationShowMessage({
								messageTitle: this.$t('erro'),
								messageIcon: 'far fa-check-circle',
								messageType: 'error',
							})
						}
					})
					.catch(() => {
						this.disableSaveButton = false
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: this.$t('erroInterno'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					})
			} else {
				this.disableSaveButton = false

				this.mutationShowMessage({
					messageTitle: message.shift(),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Atualiza produto no banco de dados
		 */
		update() {
			const prod = this.updateProdutoToPost()
			updateProduto(prod)
				.then((response) => {
					const { result: produto, responseException } = response.data
					this.disableSaveButton = false

					if (!responseException) {
						this.formataProdutoParaTabela(produto)

						const indexProduto = this.modelList.map((m) => m.id).indexOf(this.model.id)
						this.$set(this.modelList, indexProduto, produto)

						this.showForm = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
				.catch(() => {
					this.disableSaveButton = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroInterno'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(produto) =>
						this.modelsIdWithCheckedToDelete.includes(produto.id) &&
						produto.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteProdutoByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var produtosOrganizados = existeRegistroComDependencia
						.map(
							(produto) =>
								`• Produto: PR-${produto.tppr_cd_codigo} / Fazenda: ${produto.tppr_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('produtosRelacionadosAProcessamentos')}:</b> <br/><br/> ${produtosOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataProdutoParaTabela(produto) {
			produto.isCheckedToDelete = false
			produto.tppr_md_diametro_min = produto.tppr_md_diametro_min?.toFixed(2)
			produto.tppr_md_diametro_max = produto.tppr_md_diametro_max?.toFixed(2)
			produto.tppr_md_comprimento_min = produto.tppr_md_comprimento_min?.toFixed(4)
			produto.tppr_md_comprimento_max = produto.tppr_md_comprimento_max?.toFixed(4)
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.model.tppr_md_diametro_max = this.model.tppr_md_diametro_max.replace('.', ',')
			this.model.tppr_md_diametro_min = this.model.tppr_md_diametro_min.replace('.', ',')
			this.model.tppr_md_comprimento_tora = this.model.tppr_md_comprimento_tora
				.toString()
				.replace('.', ',')

			this.titleForm = `${this.$t('edit')} ${this.$t('product')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.model.tppr_md_comprimento_tora = '0,1'

			this.titleForm = `${this.$t('create')} ${this.$t('product')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
